export default "__VITE_ASSET__DMVIU7ah__"